<!--
 * @Descripttion: 标题
 * @Date: 2019-08-21 11:12:13
 * @LastEditTime: 2020-03-27 13:26:34
 -->
<template>
  <div id="title">
    <h6>{{ title }}</h6>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '取证统计'
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variable.scss';
#title {
  h6 {
    position: relative;
    padding-left: 28px;
    font-size: 16px;
    letter-spacing: 1px;
    &::before {
      content: ' ';
      display:inherit;
      height: 17px;
      width: 3px;
      background-color: $primaryColor;
      position: absolute;
      left: 20px;
      top: 2px;
    }
  }
}
</style>
